import React, { useState, useEffect, useCallback, useRef } from 'react';
import './../../App.css';
import './../Personnel/Employees.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {useTable, useSortBy} from 'react-table';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LockOpenIcon from '@mui/icons-material/LockOpen';

function PositionDesignationSalary({user, isHideSideMenu}) {
    var headerShowAccess = [
        "Id",
        "Position",
        "Section",
        "Rate",
        "Basic Rate",
        "Allowance",
        "13th Month",
        "House, Electric and Water",
        "",
    ]
    var accessorShowAccess = [
        "id",
        "positionDescription",
        "sectionDescription",
        "salary",
        "basicRate",
        "allowance",
        "thirteenthMonth",
        "utilities",
        "manage"
    ]
    var header = [
        "Id",
        "Position",
        "Section",
        "Rate",
        "Basic Rate",
        "Allowance",
        "13th Month",
        "House, Electric and Water",
    ]
    var accessor = [
        "id",
        "positionDescription",
        "sectionDescription",
        "salary",
        "basicRate",
        "allowance",
        "thirteenthMonth",
        "utilities",
    ]
    const [currentPage, setCurrentPage] = useState(1);

    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [positionDesignationSalary, setPositionDesignationSalary] = useState([]);
    const [showUploadForm, setShowUploadForm] = useState(false);

    const [showAuthentication, setShowAuthentication] = useState(false);
    const [showAccess, setShowAccess] = useState(true);
    const [isView, setIsView] = useState(false);
    const [isViewAll, setIsViewAll] = useState(true);

    // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by position");
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [positionId, setPositionId] = useState("");
    const [sectionId, setSectionId] = useState("");
    const [salary, setSalary] = useState("");
    const [allowance, setAllowance] = useState("");
    const [thirteenthMonth, setThirteenthMonth] = useState("");
    const [utilities, setUtilities] = useState("");
    const [basicRate, setBasicRate] = useState("");
    // Add
    const [showEditForm, setShowEditForm] = useState(false);
    const [editId, setEditId] = useState("");
    const [editPositionId, setEditPositionId] = useState("");
    const [editSectionId, setEditSectionId] = useState("");
    const [editSalary, setEditSalary] = useState("");
    const [editAllowance, setEditAllowance] = useState("");
    const [editThirteenthMonth, setEditThirteenthMonth] = useState("");
    const [editUtilities, setEditUtilities] = useState("");
    const [editBasicRate, setEditBasicRate] = useState("");
    //old
    const [oldEditPositionId, setOldEditPositionId] = useState("");
    const [oldEditSectionId, setOldEditSectionId] = useState("");
    const [oldEditSalary, setOldEditSalary] = useState("");
    const [oldEditAllowance, setOldEditAllowance] = useState("");
    const [oldEditThirteenthMonth, setOldEditThirteenthMonth] = useState("");
    const [oldEditUtilities, setOldEditUtilities] = useState("");
    const [oldEditBasicRate, setOldEditBasicRate] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const apiUrl =  domain + "/api/PositionDesignationSalary";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setPositionDesignationSalary(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        fetchData();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by position")
                break;
            case 1:
                setSearchPlaceholder("Search by position designation salary id")
                break;
            default:
                setSearchPlaceholder("Search by position")
                break;
        }
    }, [filterDataIndex, fetchData]);

    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };

    useEffect(() => {
        var settingIcon = document.getElementById("setting-icon");

        if(showSetting){
            //change the down icon to up
            settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
        } else {
            //change the up icon to down
            settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
        }

        const handleClickOutside = (event) => {
            if (settingRef.current && !settingRef.current.contains(event.target)) {
                if(buttonRef.current && !buttonRef.current.contains(event.target)){
                    setShowSetting(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [showSetting]);

    const handleFilter = (value) => {
        setCurrentPage(1);

        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.positionDescription.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.id.toString().includes(lowercaseValue)
                );
                break;
            default:
                break;
        }

        setPositionDesignationSalary(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            positionId: positionId,
            sectionId: sectionId,
            salary: salary,
            allowance: allowance,
            thirteenthMonth: thirteenthMonth,
            utilities: utilities,
            basicRate: basicRate,
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowAddForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Position Designation Salary", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `${data.positionId}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setPositionId("");
            setSectionId("");
            setSalary("");
            setAllowance("");
            setThirteenthMonth("");
            setUtilities("");
            setBasicRate("");
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            id: editId,
            positionId: editPositionId,
            sectionId: editSectionId,
            salary: editSalary,
            allowance: editAllowance,
            thirteenthMonth: editThirteenthMonth,
            utilities: editUtilities,
            basicRate: editBasicRate,
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${editId}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            let auditInfo = [];

            if(data.positionId !== oldEditPositionId){
                auditInfo.push({
                    setupArea: "Position Designation Salary",
                    actionTaken: "update",
                    field: "Position",
                    newValue: `${data.positionId}`,
                    oldValue: `${oldEditPositionId}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.sectionId !== oldEditSectionId){
                auditInfo.push({
                    setupArea: "Position Designation Salary",
                    actionTaken: "update",
                    field: "Section",
                    newValue: `${data.sectionId}`,
                    oldValue: `${oldEditSectionId}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.salary !== oldEditSalary){
                auditInfo.push({
                    setupArea: "Position Designation Salary",
                    actionTaken: "update",
                    field: "Salary",
                    newValue: `${data.salary}`,
                    oldValue: `${oldEditSalary}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.allowance !== oldEditAllowance){
                auditInfo.push({
                    setupArea: "Position Designation Salary",
                    actionTaken: "update",
                    field: "Allowance",
                    newValue: `${data.allowance}`,
                    oldValue: `${oldEditAllowance}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.thirteenthMonth !== oldEditThirteenthMonth){
                auditInfo.push({
                    setupArea: "Position Designation Salary",
                    actionTaken: "update",
                    field: "ThirteenthMonth",
                    newValue: `${data.thirteenthMonth}`,
                    oldValue: `${oldEditThirteenthMonth}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.utilities !== oldEditUtilities){
                auditInfo.push({
                    setupArea: "Position Designation Salary",
                    actionTaken: "update",
                    field: "Utilities",
                    newValue: `${data.utilities}`,
                    oldValue: `${oldEditUtilities}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.basicRate !== oldEditBasicRate){
                auditInfo.push({
                    setupArea: "Position Designation Salary",
                    actionTaken: "update",
                    field: "BasicRate",
                    newValue: `${data.basicRate}`,
                    oldValue: `${oldEditBasicRate}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditForm(false); // Hide the add form
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEditId("");
            setEditPositionId("");
            setEditSectionId("");
            setEditSalary("");
            setEditAllowance("");
            setEditThirteenthMonth("");
            setEditUtilities("");
            setEditBasicRate("");
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };
    const handleSubmitView = async () => {
        setIsView(true);
    };
    const handleSubmitViewAll = () => {
        setIsViewAll(true);
    };
    const handleSubmitHideAll = () => {
        setIsViewAll(false);
    };
    const handleShowAccess = () => {
        // setShowAccess(true);
        setShowAuthentication(true);
    };
    const handleAuthenticationSubmit = async () =>{
        setShowAccess(true);
        setShowAuthentication(false);
    }
    const closeAuthenticationHandleClick = () => {
        setShowAuthentication(false);
    };

    const fetchDataForPosition = useCallback(async () => {
        const apiUrl =  domain + "/api/Position/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForSection = useCallback(async () => {
        const apiUrl =  domain + "/api/Section/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);

    const generateDownloadTemplate = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('PositionDesignationSalary');

        const header = [
            'Position',
            'Section',
            'Rate',
            'Basic Rate',
            'Allowance',
            '13th Month',
            'House, Electric and Water',
        ];
        const headerRow = worksheet1.addRow(header);
        worksheet1.columns = [
            { key: 'position', width: 30 },
            { key: 'section', width: 30 },
            { key: 'dailySalary', width: 30 },
            { key: 'basicRate', width: 30 },
            { key: 'allowance', width: 30 },
            { key: 'thirteenthMonth', width: 30 },
            { key: 'utilities', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const information = [
            {
                position: '<Inventory Assitant>',
                section: '<Main Office>',
                dailySalary: '<500.00>',
                basicRate: '<500.00>',
                allowance: '<500.00>',
                thirteenthMonth: '<500.00>',
                utilities: '<500.00>',
            },
        ];

        information.forEach(info => {
            worksheet1.addRow(info);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Position_Designation_Salary_Template.xlsx');
    }, []);
    const generateDownloadRecords = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('PositionDesignationSalary');

        const header = [
            'Position',
            'Section',
            'Rate',
            'Basic Rate',
            'Allowance',
            '13th Month',
            'House, Electric and Water',
        ];
        const headerRow = worksheet1.addRow(header);
        worksheet1.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'employeeName', width: 30 },
            { key: 'salary', width: 30 },
            { key: 'basicRate', width: 30 },
            { key: 'allowance', width: 30 },
            { key: 'thirteenthMonth', width: 30 },
            { key: 'utilities', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        positionDesignationSalary.forEach(info => {
            worksheet1.addRow([
                info.positionDescription,
                info.sectionDescription,
                info.salary.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                info.basicRate.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                info.allowance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                info.thirteenthMonth.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                info.utilities.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            ]);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Position_Designation_Salary_Template.xlsx');
    }, [positionDesignationSalary]);
    const uploadEmployeeData = async (file) => {
        setLoadingRequest(true);
        const dataSection = await fetchDataForSection();
        const dataPosition = await fetchDataForPosition();
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }

        function sanitizeValueInteger(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return 0;
            }
            return value;
        }
    
        function validateData(data) {
            const missingFields = [];
    
            data.forEach((item, index) => {
                const missing = [];

                let foundSection = null;
                let foundPosition = null;

                foundSection = dataSection.find(data => 
                    data.id === item.sectionId
                );
                foundPosition = dataPosition.find(data => 
                    data.id === item.positionId
                );

                if (!Number.isInteger(item.salary)) {
                    // missing.push('Daily Salary');
                    missingFields.push(`Row ${index + 1}: Invalid value - Daily Salary`);
                }
                if (!Number.isInteger(item.allowance)) {
                    // missing.push('Allowance');
                    missingFields.push(`Row ${index + 1}: Invalid value - Allowance`);
                }
                if (!Number.isInteger(item.thirteenthMonth)) {
                    // missing.push('Allowance');
                    missingFields.push(`Row ${index + 1}: Invalid value - ThirteenthMonth`);
                }
                if (!Number.isInteger(item.utilities)) {
                    // missing.push('Allowance');
                    missingFields.push(`Row ${index + 1}: Invalid value - Utilities`);
                }
                if (!Number.isInteger(item.basicRate)) {
                    // missing.push('Allowance');
                    missingFields.push(`Row ${index + 1}: Invalid value - BasicRate`);
                }
                if (!foundSection) {
                    // missing.push('Section');
                    missingFields.push(`Row ${index + 1}: Invalid value - Section`);
                }
                if (!foundPosition) {
                    // missing.push('Position');
                    missingFields.push(`Row ${index + 1}: Invalid value - Position`);
                }

                if (missing.length > 0) {
                    missingFields.push(`Row ${index + 1}: Missing fields - ${missing.join(', ')}`);
                }
            });
    
            if (missingFields.length > 0) {
                return {
                    isValid: false,
                    message: `Invalid data in the file. Please check the mandatory fields.\n${missingFields.join('\n')}`
                };
            }
    
            return { isValid: true };
        }
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

            let bulkData = [];
    
            informations.forEach(info => {
                let foundSection = null;
                let foundPosition = null;

                foundSection = dataSection.find(data => 
                    data.description.toLowerCase() === sanitizeValue(info["Section"]).toString().toLowerCase()
                );
                foundPosition = dataPosition.find(data => 
                    data.description.toLowerCase() === sanitizeValue(info["Position"]).toString().toLowerCase()
                );

                // i will use the locations, employments etc. here below
                bulkData.push({
                    positionId: foundPosition ?
                                sanitizeValue(foundPosition.id)
                                :
                                "",
                    sectionId: foundSection ?
                                sanitizeValue(foundSection.id)
                                :
                                "",
                    salary: info["Rate"] ? 
                                sanitizeValueInteger(info["Rate"])
                                :
                                0,
                    allowance: info["Allowance"] ? 
                                sanitizeValueInteger(info["Allowance"])
                                :
                                0,
                    thirteenthMonth: info["13th Month"] ? 
                                sanitizeValueInteger(info["13th Month"])
                                :
                                0,
                    utilities: info["House, Electric and Water"] ? 
                                sanitizeValueInteger(info["House, Electric and Water"])
                                :
                                0,
                    basicRate: info["Basic Rate"] ? 
                                sanitizeValueInteger(info["Basic Rate"])
                                :
                                0,
                });
            });
    
            // Validate the bulk data
            const validation = validateData(bulkData);
            if (!validation.isValid) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage(validation.message.split('\n').map((line, index) => (
                    <div key={index}>{line}</div>
                )));
                return;
            }

            console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));

            const apiUrl = `${domain}/api/PositionDesignationSalary/bulk`;
        
            try {
                const response = await axios.post(apiUrl, bulkData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                
                await SetAuditTrail({
                    setupArea: "Position Designation Salary", 
                    actionTaken: "insert", 
                    field: "Upload", 
                    newValue: `-`, 
                    oldValue: `-`, 
                    dateSaved: new Date(), 
                    savedById: user.id
                });
                await fetchData();
                setLoadingRequest(false);
                setRequestMessage('Upload successful');
                setShowRequestMessage(true);
                setIsSuccess(true);

                
                console.log('Upload successful:', response.data);
            } catch (error) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                console.error('Error:', error);
                const errorMessage = error.response?.data?.message || 'An error occurred';
                setRequestMessage(errorMessage);
            }
        };
    
        reader.readAsArrayBuffer(file);
    };
    function handleFileUpload(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadEmployeeData(file);
    }
    const addHandleClick = (data) => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setShowEditForm(true);
        setEditId(data.id);
        setEditPositionId(data.positionId);
        setEditSectionId(data.sectionId);
        setEditSalary(data.salary);
        setEditAllowance(data.allowance);
        setEditThirteenthMonth(data.thirteenthMonth);
        setEditUtilities(data.utilities);
        setEditBasicRate(data.basicRate);
        setOldEditPositionId(data.positionId);
        setOldEditSectionId(data.sectionId);
        setOldEditSalary(data.salary);
        setOldEditAllowance(data.allowance);
        setOldEditThirteenthMonth(data.thirteenthMonth);
        setOldEditUtilities(data.utilities);
        setOldEditBasicRate(data.basicRate);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };
    const openUploadFormHandleClick  = () =>{
        setShowUploadForm(true);
    }
    const closeUploadFormHandleClick = () =>{
        setShowUploadForm(false);
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Salary Module >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Position-Designation Salary"}</span>
                            </div>
                            <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                                <h3>Position-Designation Salary</h3>
                                <div style={{width:"30%",textAlign:"right", display: showAccess ? "block" : "none"}}>
                                    <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                        <SettingsIcon/>
                                        <KeyboardArrowDownIcon id="setting-icon"/>
                                    </button>
                                    <div ref={settingRef}>
                                        {showSetting && 
                                            <SettingInit
                                            generateDownloadTemplate={generateDownloadTemplate}
                                            openUploadFormHandleClick={openUploadFormHandleClick}
                                            />}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="employeesTab-body">
                            {Filter(setFilterDataIndex)}
                            <div className="body-top row">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e)=>handleFilter(e.target.value), 
                                                                    searchPlaceholder, 
                                                                    SearchIcon)}
                                </div>
                                <div className="body-top-btn row" style={{justifyContent: "end"}}>
                                    {showAccess && < >
                                        {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                        {CreateButton("", "view-all row", generateDownloadRecords, "EXTRACT", DownloadIcon)}
                                    </>}
                                    <div style={{display: "none"}}>
                                    {showAccess ?
                                        isViewAll ?
                                            CreateButton("", "hide row", ()=>handleSubmitHideAll(), "HIDE ALL", VisibilityOffIcon)
                                            :
                                            CreateButton("", "showAccess row", ()=>handleSubmitViewAll(), "VIEW ALL", RemoveRedEyeIcon)
                                        :
                                        CreateButton("", "showAccess row", ()=>handleShowAccess(), "SHOW ACCESS", LockOpenIcon)
                                    }
                                    </div>
                                </div>
                            </div>
                            <div className="employeesTab-table container">
                                <CreateTable
                                    dataList={positionDesignationSalary}
                                    dataHeader={showAccess ? headerShowAccess : header}
                                    dataAccessor={showAccess ? accessorShowAccess : accessor}
                                    editHandleClick={editHandleClick}viewRequest={handleSubmitView}
                                    isViewAll={isViewAll}
                                    isView={isView}
                                    setIsView={setIsView}
                                    showAccess={showAccess}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    positionId={positionId}
                    sectionId={sectionId}
                    salary={salary}
                    allowance={allowance}
                    setPositionId={setPositionId}
                    setSectionId={setSectionId}
                    setSalary={setSalary}
                    setAllowance={setAllowance}

                    thirteenthMonth={thirteenthMonth}
                    setThirteenthMonth={setThirteenthMonth}
                    utilities={utilities}
                    setUtilities={setUtilities}
                    basicRate={basicRate}
                    setBasicRate={setBasicRate}

                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    editPositionId={editPositionId}
                    editSectionId={editSectionId}
                    editSalary={editSalary}
                    editAllowance={editAllowance}
                    setEditPositionId={setEditPositionId}
                    setEditSectionId={setEditSectionId}
                    setEditSalary={setEditSalary}
                    setEditAllowance={setEditAllowance}

                    editThirteenthMonth={editThirteenthMonth}
                    setEditThirteenthMonth={setEditThirteenthMonth}
                    editUtilities={editUtilities}
                    setEditUtilities={setEditUtilities}
                    editBasicRate={editBasicRate}
                    setEditBasicRate={setEditBasicRate}

                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    handleFileUpload={handleFileUpload}
            >
            </UploadForm>
            <Authentication isOpen={showAuthentication} 
                    onClose={closeAuthenticationHandleClick}
                    user={user}
                    handleSubmit={handleAuthenticationSubmit}
            >
            </Authentication>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function AddForm({isOpen, 
    onClose, 
    positionId,
    sectionId,
    salary,
    allowance,
    setPositionId,
    setSectionId,
    setSalary, 
    setAllowance, 

    thirteenthMonth,
    setThirteenthMonth,
    utilities,
    setUtilities,
    basicRate,
    setBasicRate,
    
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!positionId 
            || !sectionId 
            || !salary 
            || !allowance
            || !thirteenthMonth
            || !utilities
            || !basicRate
        ) {
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setPositionId("");
        setSectionId("");
        setSalary("");
        setAllowance("");
        setThirteenthMonth("");
        setUtilities("");
        setBasicRate("");
        setErrorState(false);
    };

    const getAllowance = useCallback(() => {
        let _salary = Number(salary);
        let _basicRate = Number(basicRate);
        let _thirteenthMonth = Number(thirteenthMonth);
        let _utilities = Number(utilities);

        let total = _salary - _basicRate - _thirteenthMonth + _utilities;
        setAllowance(total);
        
        return total;
    }, [salary, basicRate, thirteenthMonth, utilities, setAllowance]);

    useEffect(() => {
        if(isOpen){
            getAllowance()
        }
    }, [isOpen, getAllowance])
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Position Designation Salary</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Position Id</div>
                            <div className="info-item-input">
                                <PositionIdSelect positionId={positionId} setPositionId={setPositionId}/>
                            </div>
                            <span style={{
                                        visibility: !positionId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Section Id</div>
                            <div className="info-item-input">
                                <SectionIdSelect sectionId={sectionId} setSectionId={setSectionId}/>
                            </div>
                            <span style={{
                                        visibility: !sectionId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Salary</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="salary"
                                placeholder="Salary"
                                value={salary}
                                onChange={(e) => setSalary(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !salary && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Basic Rate</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                placeholder="Basic Rate"
                                value={basicRate}
                                onChange={(e) => setBasicRate(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !basicRate && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">13th Month</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                placeholder="13th Month"
                                value={thirteenthMonth}
                                onChange={(e) => setThirteenthMonth(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !thirteenthMonth && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">House, Electricity and Water</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                placeholder="House, Electricity and Water"
                                value={utilities}
                                onChange={(e) => setUtilities(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !utilities && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Allowance</div>
                            <div className="info-item-input">
                                <input
                                readOnly
                                type="number"
                                id="allowance"
                                placeholder="Allowance"
                                value={allowance}
                                style={{cursor:"not-allowed", color:"rgba(0, 0, 0, 0.356)"}}
                                />
                            </div>
                            <span style={{
                                        visibility: !allowance && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    editPositionId, 
    editSectionId, 
    editSalary, 
    editAllowance, 
    setEditPositionId,  
    setEditSectionId, 
    setEditSalary, 
    setEditAllowance, 

    editThirteenthMonth,
    setEditThirteenthMonth,
    editUtilities,
    setEditUtilities,
    editBasicRate,
    setEditBasicRate,

    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!editPositionId 
            || !editSectionId 
            || editSalary === ""
            || editAllowance === ""
            || editThirteenthMonth === ""
            || editUtilities === ""
            || editBasicRate === ""
        ){
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
    };

    const getAllowance = useCallback(() => {
        let _salary = Number(editSalary);
        let _basicRate = Number(editBasicRate);
        let _thirteenthMonth = Number(editThirteenthMonth);
        let _utilities = Number(editUtilities);

        let total = _salary - _basicRate - _thirteenthMonth + _utilities;
        setEditAllowance(total);
        
        return total;
    }, [editSalary, editBasicRate, editThirteenthMonth, editUtilities, setEditAllowance]);

    useEffect(() => {
        if(isOpen){
            getAllowance()
        }
    }, [isOpen, getAllowance])

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Position Designation Salary</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Position Id</div>
                            <div className="info-item-input">
                                <PositionIdSelect positionId={editPositionId} setPositionId={setEditPositionId}/>
                            </div>
                            <span style={{
                                        visibility: !editPositionId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Section Id</div>
                            <div className="info-item-input">
                                <SectionIdSelect sectionId={editSectionId} setSectionId={setEditSectionId}/>
                            </div>
                            <span style={{
                                        visibility: !editSectionId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Salary</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="editSalary"
                                placeholder="Salary"
                                value={editSalary}
                                onChange={(e) => setEditSalary(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: editSalary === "" && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Basic Rate</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                placeholder="Basic Rate"
                                value={editBasicRate}
                                onChange={(e) => setEditBasicRate(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !editBasicRate && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">13th Month</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                placeholder="13th Month"
                                value={editThirteenthMonth}
                                onChange={(e) => setEditThirteenthMonth(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !editThirteenthMonth && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">House, Electricity and Water</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                placeholder="House, Electricity and Water"
                                value={editUtilities}
                                onChange={(e) => setEditUtilities(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !editUtilities && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Allowance</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="editAllowance"
                                placeholder="Allowance"
                                value={editAllowance}
                                // onChange={(e) => setEditAllowance(e.target.value)}
                                style={{cursor:"not-allowed", color:"rgba(0, 0, 0, 0.356)"}}
                                />
                            </div>
                            <span style={{
                                        visibility: editAllowance === "" && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "PositionDesignationSalaryId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="PositionDesignationSalaryId">Position Designation Salary Id</option>
            </select>
        </div>
    );
};
function SettingInit({
    generateDownloadTemplate,
    openUploadFormHandleClick,
}){
    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>openUploadFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Position Designation Salary
            </div>
        </div>
    )
}
function UploadForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };


    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Position Designation Salary"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
function PositionIdSelect({positionId, setPositionId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPositionId(event.target.value);
    };

    const [positionIds, setPositionIds] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Position/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setPositionIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(positionId !== "" && positionId !== null){
            setIsSelected(true);
        } else {
            setPositionId("");
            setIsSelected(false);
        }
    }, [positionId, setPositionId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={positionId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose position id</option>
            {positionIds.map((positionId) => ( 
                SetPositionId(positionId)
            ))}
            </select>
        </div>
    );
};
function SetPositionId(positionId){
    return(
        <option id={"leaveType" + positionId.id} value={positionId.id}>{positionId.description}
        </option>
    )
    
}
function SectionIdSelect({sectionId, setSectionId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setSectionId(event.target.value);
    };

    const [sectionIds, setSectionIds] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Section/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setSectionIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(sectionId !== "" && sectionId !== null){
            setIsSelected(true);
        } else {
            setSectionId("");
            setIsSelected(false);
        }
    }, [sectionId, setSectionId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={sectionId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose section id</option>
            {sectionIds.map((sectionId) => ( 
                SetSectionId(sectionId)
            ))}
            </select>
        </div>
    );
};
function SetSectionId(sectionId){
    return(
        <option id={"leaveType" + sectionId.id} value={sectionId.id}>
            {sectionId.description}
        </option>
    )
    
}
function Authentication({
    isOpen, 
    onClose,
    user,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    // const [loading, setLoading] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = async (e) =>{
        if(!username 
            || !password
        ){
            setErrorState(true);
            return;
        }

        if(username !== "admin" || password !== "qkEcJETL"){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Invalid username or password");
            return;
        }

        /* const isAuthorize = await checkUser(e);

        if(!isAuthorize){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Invalid username or password");
            return;
        } */

        handleSubmit();
        setErrorState(false);
    };

    /* const checkUser = async (event) => {
        event.preventDefault();

        const data = {
            userName: username,
            password: password
        };

        const apiUrlFetch = domain + "/api/Authentication/login";

        try {
            setLoading(true);
            const response = await axios.post(apiUrlFetch, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if(response.data.employeePersonalInformationId === user.employeePersonalInformationId){
                return true;
            } else {
                return false;
            }
        } catch (error) {
            setLoading(false);
            return false;
        } finally {
            setLoading(false);
        }
    }; */

    const handleClose = () => {
        onClose();
        setUsername("")
        setPassword("")
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Authentication</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Username</div>
                            <div className="info-item-input">
                                <input
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !username && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Password</div>
                            <div className="info-item-input">
                                <input
                                type='password'
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !password && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                ENTER
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {/* {loading ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            } */}
        </>
    );
}
export function CreateTable({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    editHandleClick, 
    viewRequest, 
    isViewAll, 
    isView,
    setIsView,
    deleteHandleClick,
    showAccess,

    currentPage, setCurrentPage
}) {
    // const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [viewCell, setViewCell] = useState(null);

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleViewRequest = (cellKey) => {
        setViewCell(cellKey);
        viewRequest(false); // Or whatever logic you need to handle the view request
        setIsView(true);
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfo header={cell.render("Cell").props.column.Header}
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            viewRequest={() => handleViewRequest(cell.getCellProps().key)}
                                            isViewAll={isViewAll}
                                            isView={viewCell === cell.getCellProps().key}
                                            setIsView={setIsView}
                                            showAccess={showAccess}
                                            />
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo({header, 
    _cell, 
    editHandleClick, 
    viewRequest, 
    isViewAll, 
    isView,
    setIsView,
    showAccess,
    deleteHandleClick
}) {
    const data = _cell.render("Cell").props.row.original;

    const [isExpandedCell, setIsExpandedCell] = useState(null);

    const handleCellClick = () => {
        if (isExpandedCell === _cell.getCellProps().key) {
            setIsExpandedCell(null); // Collapse the current cell if clicked again
        } else {
            setIsExpandedCell(_cell.getCellProps().key); // Expand the clicked cell
            viewRequest(_cell.getCellProps().key); // Pass the cell key to handle the view request
        }
    };

    //Double type data
    if (header === "Rate" || header === "Basic Rate" || header === "Allowance" || header === "13th Month" || header === "House, Electric and Water") {
        const value = _cell.render("Cell").props.value;
        // Check if value is a number
        const isNumber = typeof value === 'number';
    
        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if (!isNumber) {
            return (
            <td {..._cell.getCellProps()}>
                {_cell.render("Cell")}
            </td>
            );
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        if (isViewAll) {
            return (
                <td>
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        {formattedNumber}
                        {/* <Tooltip text="Hide">
                            <div className='history' style={{padding:"0 5px", marginRight:"5px"}} onClick={handleCellClick }><VisibilityOffIcon/></div>
                        </Tooltip> */}
                    </div>
                </td>
            );
        }

        if (isExpandedCell === _cell.getCellProps().key) {
            return (
                <td>
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        {formattedNumber}
                        <Tooltip text="Hide">
                            <div className='history' style={{padding:"0 5px", marginRight:"5px"}} onClick={handleCellClick }><VisibilityOffIcon/></div>
                        </Tooltip>
                    </div>
                </td>
            );
        }

        return (
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    *****
                    {showAccess ?
                        <Tooltip text="View">
                            <div className='history' style={{padding:"0 5px", marginRight:"5px"}} onClick={handleCellClick }><RemoveRedEyeIcon/></div>
                        </Tooltip>
                        :
                        <></>
                    }
                </div>
            </td>
        );
    }

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '70%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
export default PositionDesignationSalary
